// extracted by mini-css-extract-plugin
export var bannerAlert = "styles-module--bannerAlert--536a2";
export var controls = "styles-module--controls--54204";
export var linksContainer = "styles-module--linksContainer--98923";
export var wrapper = "styles-module--wrapper--d556f";